
import teamMessage from './teamMessage/reducer';
import replyToMessage from './replyToMessage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  teamMessage,
  replyToMessage
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/emojis/reducer.js
 **/